<div class="form-group">
    <label class="input-label">Field type:</label>
    <input disabled="true"
           type="text"
           name="fieldOptions.inputType"
           value="{{fieldOptions.inputType}}"
           [(ngModel)]="fieldOptions.inputType"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>